<template>
  <div>
    <div class="container ">
      <div
        v-if="!showResult"
        class="uk-card uk-card-default sidebar"
      >
        <div class="uk-card-body uk-padding-remove">
          <wizard-sideBar />
        </div>
      </div>
      <div
        class="uk-flex"
        style="width: 100%;"
      >
        <div
          class="uk-card uk-card-default main"
          style="width: 100%;"
        >
          <div
            class="uk-flex optionSelected"
          >
            <div class="item-selected uk-text-center">
              <label for="aerialHeader">
                <figure>
                  <img
                    v-if="transportMode === transportModeTypeEnum.aerial"
                    src="../assets/img/costs/airplane.jpg"
                    width="35"
                    alt="Aéreo"
                  >
                  <img
                    v-if="transportMode === transportModeTypeEnum.maritime"
                    src="../assets/img/costs/boat.png"
                    width="35"
                    alt="Aéreo"
                  >
                  <figcaption
                    class="title-option-selected"
                  >
                    <span v-if="transportMode === transportModeTypeEnum.aerial">Aéreo</span>
                    <span v-if="transportMode === transportModeTypeEnum.maritime">Marítimo</span>
                  </figcaption>
                </figure>
              </label>
            </div>
            <div class="item-selected uk-text-center">
              <label for="importHeader">
                <figure>
                  <img
                    v-if="journeyDirection === directionTypeEnum.import"
                    src="../assets/img/costs/Import.png"
                    width="35"
                    alt="Importación"
                  >
                  <img
                    v-if="journeyDirection === directionTypeEnum.export"
                    src="../assets/img/costs/Export.png"
                    width="35"
                    alt="Importación"
                  >
                  <figcaption
                    class="title-option-selected"
                  >
                    <figcaption>
                      <span v-if="journeyDirection === directionTypeEnum.import">Importación</span>
                      <span v-if="journeyDirection === directionTypeEnum.export">Exportación</span>
                    </figcaption>
                  </figcaption>
                </figure>
              </label>
            </div>
            <div class="item-selected uk-text-center">
              <label for="dollyTypeHeader">
                <figure>
                  <img
                    v-if="dollyType === dollyTypeEnum.dryLoad"
                    src="../assets/img/costs/dolly.png"
                    width="35"
                    alt="Carga Seca"
                  >
                  <img
                    v-if="dollyType === dollyTypeEnum.reefer"
                    src="../assets/img/costs/Reefer.png"
                    width="35"
                    alt="Carga Seca"
                  >
                  <figcaption>
                    <figcaption
                      class="title-option-selected"
                    >
                      <span v-if="dollyType === dollyTypeEnum.dryLoad">Carga Seca</span>
                      <span v-if="dollyType === dollyTypeEnum.reefer">Reefer</span>
                    </figcaption>
                  </figcaption>
                </figure>
              </label>
            </div>
          </div>
          <wizard-content />
        </div>
        <div
          v-if="!showResult"
          class="uk-card uk-card-default uk-padding-remove description"
          style="width: 25%;"
        >
          <selection-message />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import selectionMessage from '../components/ColdChainComponents/SelectionMessage'
import WizardSideBar from '../components/TransportChainComponents/WizardComponents/WizardSideBar.vue'
import WizardContent from '../components/TransportChainComponents/WizardComponents/WizardContent.vue'
import { transportModeTypeEnum, directionTypeEnum, dollyTypeEnum } from '../types'
import { ComponentEnum } from '../enums'
export default {
  components: {
    WizardSideBar,
    WizardContent,
    selectionMessage
  },
  data () {
    return {
      transportModeTypeEnum,
      directionTypeEnum,
      dollyTypeEnum
    }
  },
  computed: {
    ...mapState([
      'showResult'
    ]),
    ...mapGetters([
      'transportMode',
      'journeyDirection',
      'dollyType',
      'availablePath',
      'storeShippingFeatures',
      'incoterm'
    ])
  },
  methods: {
    visibleComponents () {
      this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.WarehouseLogistics, status: true }])
      this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ReceptionLogistics, status: true }])
      this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ShippingLogistics, status: true }])
    }
  }
}
</script>

<style scoped>
.container{
    display: flex;
    justify-content: space-between;
    margin: 0px;
    width: 100%;
    height: auto;
    min-height: 522px;

}
.sidebar{
  width: 20%;
  max-width: 200px;
  min-width: 190px;
  padding: 10px 0px;
}
.main{
  padding-top: 5px;
}

.optionSelected{
    justify-content:flex-end;
    min-height: 30px;
    max-height: 30px;
    margin-bottom: 15px;
}

.optionSelected figure{
  margin: 0px
}
.item-selected{
  margin: 0px 10px;
}
.title-option-selected span{
  font-size: 10px;
}

@media screen and (max-width: 1050px){
.description{
  display: none;
}

}
@media screen and (max-width: 879px){
.title{
  font-size: 13px;
}

@media screen and (max-width: 680px){
  .sidebar{
    width: 20%;
    min-width: 170px;
  }
}

}
@media screen and (max-width: 600px){

  .sidebar{
    width: 100%;
    padding: 0px 0px 10px 0px ;
    max-width: none;
    min-width: 190px;
  }
  .title{
    display: none;
  }
  .title-option-selected{
    display: none;
  }
  .container{
    display: block;
    min-height: 411px;

  }
  .optionSelected{
    justify-content: center;
    margin-bottom: 10px;
  }
  img{
    width: 30px;
  }
}

</style>
